export default "__VITE_ASSET__DiM6mD_g__"